import { render, staticRenderFns } from "./Datatype.vue?vue&type=template&id=24575c82&"
import script from "./Datatype.vue?vue&type=script&lang=js&"
export * from "./Datatype.vue?vue&type=script&lang=js&"
import style0 from "./Datatype.vue?vue&type=style&index=0&id=24575c82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports